var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"scroll-rating-tagging",staticClass:"scroll-rating-tagging",attrs:{"id":"scroll-rating-tagging"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }